import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/linear-arrow-right.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  src: _imports_0,
  alt: "Arrow Icon",
  class: "prototype-tile-icon"
}
const _hoisted_6 = {
  key: 3,
  class: "prototype-sub-list"
}
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.prototype.name === 'App')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("p", { class: "category" }, "Customer Portals", -1)
        ]))]))
      : _createCommentVNode("", true),
    (_ctx.prototype.name === 'Mass Notification')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("p", { class: "category" }, "Resident and Family Communications", -1)
        ]))]))
      : _createCommentVNode("", true),
    (_ctx.prototype.name === 'Power Outage')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("p", { class: "category" }, "Staff Communications", -1)
        ]))]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["prototype-tile", { active: _ctx.isSelected }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleTap && _ctx.handleTap(...args)))
    }, [
      _createElementVNode("img", {
        src: _ctx.targetIcon,
        alt: "Target Icon",
        class: "icon"
      }, null, 8, _hoisted_4),
      _createElementVNode("h4", null, _toDisplayString(_ctx.prototype.name), 1),
      (_ctx.prototype.items)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _imports_0,
            alt: "Arrow Icon",
            class: _normalizeClass(["prototype-tile-icon", { 'prototype-tile-icon--expanded': _ctx.isExpanded }])
          }, null, 2))
        : (_openBlock(), _createElementBlock("img", _hoisted_5))
    ], 2),
    (_ctx.prototype.items && _ctx.isExpanded)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prototype.items, (item, subindex) => {
            return (_openBlock(), _createElementBlock("li", {
              key: subindex,
              class: "prototype-sub-tile",
              onClick: ($event: any) => (_ctx.handleSubTap(subindex))
            }, [
              _createElementVNode("h5", {
                class: _normalizeClass(_ctx.subItemClass(subindex))
              }, _toDisplayString(item.name), 3)
            ], 8, _hoisted_7))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}